import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { PartyPopper, Ticket as TicketIcon, Calendar, Download } from "lucide-react";
import { PillButton } from "../../components/ui/PillButton";
import { TicketPass } from "../../components/ui/TicketPass";
import { Confetti } from "../../components/ui/Confetti";
import { useApp } from "../../context/AppContext";
import { toast } from "sonner";

export default function TicketConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { getTicket } = useApp();
  const codes = location.state?.codes || [];

  if (!codes.length) return <Navigate to="/tickets" replace />;

  const tickets = codes.map((c) => getTicket(c)).filter(Boolean);
  const first = tickets[0];

  return (
    <div className="relative max-w-3xl mx-auto px-4 py-12">
      <Confetti />
      <div className="text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-lime flex items-center justify-center shadow-playful animate-pop-in">
          <PartyPopper className="w-10 h-10 text-sea-deep" />
        </div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl text-coral sticker-text-sm">You're In! 🎉</h1>
        <p className="mt-3 text-lg font-bold text-sea-deep/80">Petualangan BLTR 2026 kamu dimulai dari sini.</p>
      </div>

      <div className="mt-10 space-y-8">
        {tickets.map((t) => (
          <TicketPass key={t.ticketCode} ticket={t} />
        ))}
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
        <PillButton size="lg" onClick={() => navigate("/book-activity", { state: { code: first.ticketCode } })} data-testid="confirm-book-activities">
          <Calendar className="w-5 h-5" /> Book Activities
        </PillButton>
        <PillButton size="lg" variant="sky" onClick={() => navigate("/my-booking", { state: { code: first.ticketCode } })} data-testid="confirm-view-ticket">
          <TicketIcon className="w-5 h-5" /> View My Ticket
        </PillButton>
        <PillButton size="lg" variant="white" onClick={() => { toast.success("Menyiapkan tiket untuk diunduh..."); setTimeout(() => window.print(), 300); }} data-testid="confirm-download">
          <Download className="w-5 h-5" /> Download
        </PillButton>
      </div>
    </div>
  );
}
